import { FC } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PaginatorProps {
  currentPage: number;
  onPageChange: any;
  totalPages: number;
}

const Paginator: FC<PaginatorProps> = ({
  currentPage,
  onPageChange,
  totalPages,
}) => {
  const { t } = useTranslation("table");

  return (
    <div className="d-flex flex-row justify-content-between align-items-center">
      <Button
        className="custom-primary-button"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        {`< ${t("previous")}`}
      </Button>
      {currentPage}
      <Button
        className="custom-primary-button"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        {`${t("next")} >`}
      </Button>
    </div>
  );
};

export default Paginator;
